import React from 'react';
import { useCart } from '../../context/CartContext';
import './Notification.css';

const Notification = () => {
  const { notification, setNotification } = useCart();

  if (!notification) return null;

  return (
    <div className="notification-toast">
      <div className="notification-content">
        <span className="notification-message">{notification}</span>
        <button className="notification-close" onClick={() => setNotification(null)}>×</button>
      </div>
    </div>
  );
};

export default Notification;
